import { render, staticRenderFns } from "./PaymentReceipt.vue?vue&type=template&id=26b1b3a0"
import script from "./PaymentReceipt.vue?vue&type=script&lang=js"
export * from "./PaymentReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports